(function(){
  'use strict';
  if(window.PTB2BEditorFrame) return;

  var QUICKMODE_URL = 'https://planet-tree.de/pages/b2b-quickmode';
  var REV = '20260918-certificate-quantity-v1';

  function readSession(key){
    try{ return String(window.sessionStorage.getItem(key) || '').trim(); }
    catch(_error){ return ''; }
  }

  function readLocal(key){
    try{ return String(window.localStorage.getItem(key) || '').trim(); }
    catch(_error){ return ''; }
  }

  function launchContext(){
    var params = new URLSearchParams(window.location.search);
    var directToken = String(params.get('token') || params.get('portal_token') || '').trim();
    var directRef = String(params.get('customer_ref') || params.get('b2b_customer') || '').trim();
    if(directToken) return { token:directToken, customerRef:directRef };

    var adminRef = readSession('pt_b2b_portal_admin_customer_ref');
    var adminToken = readSession('pt_b2b_portal_admin_launch_token');
    var lastRef = readSession('pt_b2b_portal_last_customer_ref');
    if(adminToken && adminRef && (!lastRef || adminRef === lastRef)){
      return { token:adminToken, customerRef:adminRef };
    }

    var localToken = readLocal('pt_b2b_portal_token');
    if(localToken) return { token:localToken, customerRef:lastRef };

    /* Never combine a token with a customer reference from another storage
       source. With a token but no coherent reference the authenticated /me
       response is the only authority for the draft key. */
    return { token:'', customerRef:'' };
  }

  function open(mode){
    var target = new URL(QUICKMODE_URL);
    var context = launchContext();
    var portalToken = context.token;
    var portalCustomerRef = context.customerRef;
    if(portalToken) target.searchParams.set('token',portalToken);
    if(portalCustomerRef){
      target.searchParams.set('customer_ref',portalCustomerRef);
      target.searchParams.set('b2b',portalCustomerRef);
      target.searchParams.set('b2b_customer',portalCustomerRef);
    }else{
      target.searchParams.set('b2b','1');
    }
    var normalizedMode = mode === 'summary' ? 'summary' : (mode === 'event' ? 'event' : 'personal');
    target.searchParams.set('b2b_mode',normalizedMode);
    target.searchParams.set('portal_return','/pages/b2b-portal');
    target.searchParams.set('v',REV);
    /* Safari may otherwise restore the previous, already closed quickmode
       document from its page cache. Every launch must be a new document. */
    target.searchParams.set('open_id',String(Date.now()) + '-' + Math.random().toString(36).slice(2,8));
    window.location.assign(target.toString());
  }

  function ensureEventCard(){
    var existing = document.getElementById('ptb2b-start-event');
    if(existing){
      existing.querySelector('strong').textContent = 'Zertifikate für Verkäufe & Anlässe';
      var text = existing.querySelector('.ptb2b-modeText');
      if(text) text.textContent = 'Ohne Empfängernamen: ein Zertifikat oder mehrere mit gleichem Anlass erstellen – zum Beispiel ein Baum pro verkauftem Produkt.';
      return true;
    }
    var subscription = document.getElementById('ptb2b-start-subscription');
    if(!subscription || !subscription.parentNode) return false;
    var card = document.createElement('button');
    card.className = 'ptb2b-modeCard ptb2b-modeCard--event';
    card.id = 'ptb2b-start-event';
    card.type = 'button';
    card.innerHTML = '<span class="ptb2b-modeIcon" aria-hidden="true">🎉</span>' +
      '<strong>Zertifikate für Verkäufe &amp; Anlässe</strong>' +
      '<span class="ptb2b-modePrice" id="ptb2b-mode-price-event">ab 6,00 Euro netto</span>' +
      '<span class="ptb2b-modeText">Ohne Empfängernamen: ein Zertifikat oder mehrere mit gleichem Anlass erstellen – zum Beispiel ein Baum pro verkauftem Produkt.</span>' +
      '<span class="ptb2b-modeCta">Jetzt starten</span>';
    subscription.parentNode.insertBefore(card,subscription);
    return true;
  }

  if(!ensureEventCard()){
    document.addEventListener('DOMContentLoaded',ensureEventCard,{once:true});
    var eventCardObserver = new MutationObserver(function(){
      if(ensureEventCard()) eventCardObserver.disconnect();
    });
    eventCardObserver.observe(document.documentElement,{childList:true,subtree:true});
    window.setTimeout(function(){ eventCardObserver.disconnect(); },12000);
  }

  document.addEventListener('click',function(event){
    var trigger = event.target && event.target.closest
      ? event.target.closest('#ptb2b-start-personal,#ptb2b-new-order,#ptb2b-start-summary,#ptb2b-start-event')
      : null;
    if(!trigger) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open(trigger.id === 'ptb2b-start-summary' ? 'summary' : (trigger.id === 'ptb2b-start-event' ? 'event' : 'personal'));
  },true);

  window.PTB2BEditorFrame = { open:open, close:function(){} };
})();
